import { useEffect } from 'react';
import { useVideoContext } from '@gfazioli/mantine-video';

export default function VideoPlayerBridge({ onPlayerState }) {
  const { currentTime, duration, seek, play } = useVideoContext();
  useEffect(() => {
    onPlayerState({ currentTime, duration, seek, play });
  }, [currentTime, duration, seek, play, onPlayerState]);
  return null;
}
